module.exports = __webpack_public_path__ + "f6122e91.svg";